















import {Vue, Component, Prop} from 'vue-property-decorator';
import {Title} from '@/components/Title';
import {NavigationPanel} from '@/components/NavigationPanel';

@Component({
  name: 'ProfilePayments',
  components: {
    Title,
    NavigationPanel,
  },
  mounted() {
    window.addEventListener('resize', this.mobView);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.mobView);
  },
  props: {
    pageTitle: {
      type: String,
      default: '',
    },
    childrenLinks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mobWidth: false,
    };
  },
  methods: {
    mobView() {
      this.mobWidth = window.innerWidth < 1100;
    },
  },
})
export default class ProfilePayments extends Vue {}
